var api = require("!../../../../../.yarn/__virtual__/style-loader-virtual-fc850ebd53/0/cache/style-loader-npm-1.1.3-d7b74fe8b4-1a0b3de428.zip/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../.yarn/__virtual__/css-loader-virtual-b2c8f92882/0/cache/css-loader-npm-3.4.2-300ee159b3-dbd80f052b.zip/node_modules/css-loader/dist/cjs.js!./map-loader.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;